'use client';

import type { SpatialMascotState } from './SpatialMascot.types';

export type { SpatialMascotState } from './SpatialMascot.types';

/** Built-in mascot with a state ring, sized by its caller's box. */
export function MascotGlyph({ state = 'idle' }: { state?: SpatialMascotState }) {
  return (
    <div className="spatial-mascot" role="img" aria-label="Chetty">
      <div className={`spatial-mascot-fallback spatial-mascot-fallback--${state}`} aria-hidden>
        <span className="spatial-mascot-fallback__ring spatial-mascot-fallback__ring--outer" />
        <span className="spatial-mascot-fallback__ring spatial-mascot-fallback__ring--inner" />
        {/* eslint-disable-next-line @next/next/no-img-element -- bundled mascot artwork. */}
        <img src="/icon.png" alt="" draggable={false} />
      </div>
    </div>
  );
}
